enum HardcodedSalesDemoPath {
  Ads = '/ads/',
  Vvc = '/vvc/',
  AnalyticsBitrateDemo = '/analytics/bitrate-demo/',
  BehavioralPlayback = '/behavioral-playback/',
  ChunkBased3PassEncoding = '/chunk-based-3-pass-encoding/',
  CloudEncodingDemo = '/cloud-encoding/demo/',
  CloudEncodingAws = '/cloud-encoding/demo/?cloud=aws',
  CloudEncodingGc = '/cloud-encoding/demo/?cloud=gc',
  CustomizableUi = '/customizable-ui/',
  Csse = '/csse/',
  DolbyVision = '/dolby-vision/',
  ForensicWatermarking = '/forensic-watermarking-nagra/',
  GrassValley = '/grass-valley/',
  Drm = '/drm/',
  LiveStreaming = '/livestreaming/',
  LiveStreamingSRT = '/livestreaming/?partner=srt',
  LiveStreamingZixi = '/livestreaming/?partner=zixi',
  LiveToVod = '/live-to-vod/',
  LowLatencyStreaming = '/low-latency-streaming/',
  ModularPlayer = '/modular-player/',
  Multicodec = '/multicodec/',
  NativeSdks = '/native-sdks/',
  OfflinePlayback = '/offline-playback/',
  OnPremiseEncodingDemo = '/on-premise/demo/',
  PerTitleEncoding = '/per-title-encoding/',
  PerTitleLive = '/per-title-live/',
  PlayerAnalyticsBundling = '/player-analytics-bundling/',
  PerTitleEncodingDemo = '/per-title-encoding/demo/',
  Ssai = '/ssai/',
  SsaiYospace = '/ssai/?partner=yospace',
  SsaiMediaTaylor = '/ssai/?partner=mediaTaylor',
  SsaiGoogleDFP = '/ssai/?partner=googleDFP',
  SsaiBroadpeak = '/ssai-broadpeak/',
  StreamLab = '/stream-lab/',
  Superresolution = '/superresolution',
  Csw = '/csw/',
  ThreePassEncoding = '/3-pass-encoding/',
  VrPlayer = '/vr-player/',
  perShotEncoding = '/per-shot-encoding/',
  Videon = '/videon/'
}

export default HardcodedSalesDemoPath;
